export function siblings( elem  ) {

    return Array.prototype.filter.call(elem.parentNode.children, function (sibling) {
        return sibling !== elem;
    })
}
